import coverHome     from '../assets/images/waabm_audio_spectrum2.png';
import callOutImageHome from '../assets/images/waabm-we-know.png';
import coverMusic    from '../assets/images/waabm_audio_spectrum.png';
import coverProjects from '../assets/images/abstract_painting_colors.jpg';
import coverAbout    from '../assets/images/waabm_studio_pink.png';
import coverContact  from '../assets/images/waabm-cover-pixel-01.jpg';
import { getProjectPage, projectNavChildren } from './projects.js';
import { features } from './site.js';

// Single source of truth for all per-page settings.
// bodyBg: image  = full-page background (independent)
// cover: image   = header cover area image (optional)
// bgTarget: 'cover' | 'cover-container'  = how the header cover is rendered
// callout: { title, subtitle, imageSrc, iframeSrc, cta: { label, href } } = renders a CalloutCard inside #cover-container (replaces the <h1> title)
export const pages = [
  { 
    path: '/',
    title: '',
    theme: 'black',
    bodyBg: coverHome,
    cover: '',
    callout: {
      title: 'New Release: We Know',
      subtitle: '(coming soon)',
      imageSrc: callOutImageHome,
      label: 'Out now on all platforms',
      cta: {
        label: 'Listen',
        href: 'https://soundcloud.com/waabm',
      },
    },
    bgTarget: 'cover-container',
    navLabel: 'Home',
    navEnd: true 
  },
  { 
    path: '/listen',
    title: 'Listen',
    theme: 'light',
    bgTarget: 'cover',
    cover: coverMusic,
    navLabel: 'Listen'
  },
  { 
    path: '/projects',
    title: 'Projects',
    theme: 'black', 
    bodyBg: coverProjects,
    cover: coverProjects,
    bgTarget: 'cover-container',
    navLabel: 'Projects',
    children: projectNavChildren 
  },
  ...(features.blog ? [{
    path: '/blog',
    title: 'Blog',
    theme: 'light',
    bgTarget: 'cover',
    cover: coverAbout,
    navLabel: 'Blog',
  }] : []),
  { 
    path: '/about',
    title: 'About',
    theme: 'light', 
    bgTarget: 'cover',
    cover: coverAbout,
    navLabel: 'About'
  },
  { 
    path: '/contact',
    title: 'Contact',
    theme: 'light',
    bgTarget: 'cover',
    cover: coverContact,
    navLabel: 'Contact'
  },
];

// Convenience lookup by path
const pageMap = Object.fromEntries(pages.map(p => [p.path, p]));
export function getPage(pathname) {
  // Handle /blog/:slug sub-pages
  if (features.blog && pathname.startsWith('/blog/')) {
    return pageMap['/blog'] ?? pageMap['/'];
  }

  // Handle /projects/:slug sub-pages
  const projectsPage = pageMap['/projects'];
  if (pathname.startsWith('/projects/')) {
    const projectSlug = pathname.replace('/projects/', '').split('/')[0];
    const projectConfig = getProjectPage(projectSlug);
    if (projectConfig) {
      return {
        ...projectsPage,
        theme:     projectConfig.theme     ?? projectsPage.theme,
        bodyBg:    projectConfig.bodyBg    ?? projectsPage.bodyBg,
        bgTarget:  projectConfig.bgTarget  ?? projectsPage.bgTarget,
        cover:     projectConfig.cover     ?? projectsPage.cover,
        callout:   projectConfig.callout   ?? projectsPage.callout,
        showTitle: projectConfig.showTitle ?? true,
      };
    }
    return projectsPage;
  }
  return pageMap[pathname] ?? pageMap['/'];
}

// Nav links derived from pages
export const links = pages.map(({ path, navLabel, navEnd, children }) => ({
  to: path,
  label: navLabel,
  ...(navEnd && { end: true }),
  ...(children && { children }),
}));
